import List from '@material-ui/core/List'
import React from 'react'
import { connect } from 'react-redux'
import image from '../../assets/images/szambelan_zalaczniki.svg'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import MainStyle from '../../styles/MainStyle'
import ZalacznikiStyle from '../../styles/ZalacznikiStyle'
import ZalacznikiRow from '../../components/zalaczniki/ZalacznikiRow'
import InfoPanel from '../../components/InfoPanel'
import { controlHasError } from '../../lib/errorHandler'
import Szambelan from '../../components/Szambelan'
import * as actions from '../../store/actions'

class Zalaczniki extends React.Component {
  expandContent = () => {
    return (
      <>
        <div>
          W tym miejscu należy dodać jedynie opisy oraz pliki załączników
          składające się na informację dodatkową lub inny dokument
          <br /> z art. 48 ustawy o rachunkowości. <br />
          <br />
          Pozostałe dokumenty, m.in.:
        </div>
        <ul>
          <li>
            opinię biegłego rewidenta / sprawozdanie z badania rocznego
            sprawozdania finansowego
          </li>
          <li>uchwałę o podziale zysku bądź pokryciu straty</li>
          <li>
            uchwałę lub postanowienie o zatwierdzeniu rocznego sprawozdania
            finansowego
          </li>
          <li>sprawozdanie z działalności </li>
          <li>sprawozdanie z płatności na rzecz administracji publicznej</li>
        </ul>
        należy przesłać do adresata sprawozdania jako odrębne pliki w dowolnym
        formacie.
      </>
    )
  }

  rolledContent = () => {
    return (
      <div>
        W tym miejscu należy dodać jedynie opisy oraz pliki załączników
        składające się na informację dodatkową lub inny dokument
        <br /> z art. 48 ustawy o rachunkowości.
      </div>
    )
  }

  render() {
    const {
      idPliku,
      validityErrors,
      onSetSectionDataArray,
      handleAdd,
      handleDelete,
      zalaczniki,
      shortenedView,
      onDowloadAttachment,
    } = this.props
    const struktura = {
      Opis: '',
      Nazwa: '',
    }
    return (
      <MainStyle shortenedView={shortenedView}>
        {!shortenedView && (
          <InfoPanel
            canExpand={true}
            exptandContent={this.expandContent()}
            rolledContent={this.rolledContent()}
          />
        )}
        <ZalacznikiStyle>
          {!shortenedView && (
            <div className="attachment-header">
              <span>INFORMACJA DODATKOWA I ZAŁĄCZNIKI</span>
              <ButtonAddInfo
                label="DODAJ INFORMACJĘ DODATKOWĄ"
                structure={struktura}
                handleAdd={handleAdd}
              />
            </div>
          )}

          {zalaczniki.length > 0 ? (
            <div className="container">
              <div className="listLabel caption">
                <p>OPIS</p> <p>ZAŁĄCZONY PLIK</p>
              </div>
              <List>
                {zalaczniki.map((data, index) => (
                  <ZalacznikiRow
                    onSetSectionDataArray={onSetSectionDataArray}
                    onDowloadAttachment={onDowloadAttachment}
                    handleDelete={handleDelete}
                    key={index}
                    data={data}
                    index={index}
                    idPliku={idPliku}
                    hasError={(name, value) =>
                      controlHasError(validityErrors, name, value)
                    }
                  />
                ))}
              </List>
            </div>
          ) : (
            !shortenedView && (
              <Szambelan
                text={
                  <>
                    Jeszcze nie dodano <br /> informacji dodatkowej
                  </>
                }
                logo={image}
              />
            )
          )}
          {shortenedView && (
            <div className="placeholder">
              {zalaczniki.length === 0 && (
                <span className="medium-emphasis-subtitle-1">
                  Jeszcze nie dodano informacji dodatkowej
                </span>
              )}
              <div className="add-button">
                <ButtonAddInfo
                  label="DODAJ INFORMACJĘ DODATKOWĄ"
                  structure={struktura}
                  handleAdd={handleAdd}
                  variant="outlined"
                />
              </div>
            </div>
          )}
        </ZalacznikiStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    idPliku: state.sprawozdanie.header.Id,
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors.filter(
          value =>
            value.TypSekcji === 'Zalaczniki' ||
            value.TypSekcji === 'InformacjeDodatkoweSkonsolidowane',
        )
      : [],
  }
}

const mapDispatchToProps = dispatch => ({
  onDowloadAttachment: (id, name) => {
    return dispatch(actions.downloadAttachment(id, name))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Zalaczniki)
